import ExoAvatar from '../../../components/exo/ExoAvatar';
import { renderHours } from '../../time-tracking/worktime';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { tokens } from '../../../global/theme/tokens';
import RenderHTML from '../../../components/preview/RenderHTML';
import { Box, Typography, useTheme } from '@mui/material';
import AvTimerIcon from '@mui/icons-material/AvTimer';

const WpTimeTrackingUserCard = ({ userData }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const navigate = useNavigate();

  const totalMinutes =
    (moment(userData.timeEnd).utc() - moment(userData.timeStart).utc()) /
    (1000 * 60);

  return (
    <>
      <Box
        className="flex items-center w-full p-2 rounded-lg flex-row gap-3 transition-transform"
        sx={{
          cursor: 'default',
          border: `1px solid transparent`,
        }}
      >
        <ExoAvatar
          picture={userData?.employee?.picture?.temporaryUrl}
          name={`${userData?.employee?.firstName} ${userData?.employee?.lastName}`}
          size="35"
          onClick={() => navigate(`/employees/${userData?.employee?.id}`)}
        />

        <Box className="flex flex-col justify-start w-full">
          {/* Name and Time Row */}
          <Box
            className="flex items-center w-full"
            sx={{ justifyContent: 'space-between' }}
          >
            <Typography fontSize="14px" fontWeight={600}>
              {userData?.employee?.firstName} {userData?.employee?.lastName}
            </Typography>

            <Typography
              fontSize="12px"
              fontWeight={600}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                opacity: 0.7,
              }}
            >
              <AvTimerIcon sx={{ fontSize: 16 }} />
              {moment(userData.timeStart).format('DD MMM YYYY')} -{' '}
              {renderHours(totalMinutes)} h
            </Typography>
          </Box>

          {/* Comment */}
          {userData?.comment && (
            <Typography fontSize="12px" variant="h6">
              <RenderHTML HTML={userData?.comment} />
            </Typography>
          )}
        </Box>
      </Box>
      <Box
        sx={{ bgcolor: colors.card }}
        className="w-full h-[1px] rounded-full"
      />
    </>
  );
};

export default WpTimeTrackingUserCard;
